const orderRefundScore = () =>
  import('@/views/main/order/refund-list/refund-list.vue')
export default {
  path: '/main/order/orderRefundScore',
  name: 'orderRefundScore',
  component: orderRefundScore,
  children: []
}
